module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-2-lowlands"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "groningen-the-netherlands-19301949"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("up, I started to look around. I would study the interior of the church, trying to figure out why different parts were there. Why were those steel rods linking the opposite walls? Why were there arches in the brick wall, and why were the tops of other openings just straight? After many Sundays of contem- plation, I was beginning to understand the relation between structure and gravity. It was a surprise to discover that it was gravity that made it possible for buildings to soar to such great heights.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The next Sunday project was to listen to what the minister was saying. Usually there would be three points the preacher was making, and in the end all would be well. I found that there was a degree of predictability in what he would be saying next, and to introduce an element of excitement I lay bets with myself. But the real excitement came when I was old enough to be allowed to sit away from my parents in the gallery. There, I could read the Bible during the sermon, but without supervision of what I was reading. I found all the parts in the ancient book that told me of love and sex in times that existed thousands of years ago, and I was moved by the beauty of the descriptions and praise of love.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("There were several Reformed churches in the city: one each to the north, east, south, and west of the centre of the city. There were many churches of all kinds, and gradually my acceptance that this was the way the world was, changed to curiosity. Why did we walk to church in the one direction and why did other people walk to church in the opposite direction? Gradually I found out more about the others. In the street where we lived was a Baptist Church, but its stately edifice was behind a wrought iron gate that was mostly closed. There were also two exotic churches. Nearby was a Wallonia-based Protes- tant church where the minister preached in French, and a bit further away was a Synagogue, but this was closed by the Nazis.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("I discovered that the Roman Catholic church-building opposite the university was always open and that you could just walk into the dark interior. There, under windows that glowed like illuminated Persian carpets, you could listen to the organ, hear tiny silver bells, wonder why boys were singing, count candles, look at statues that were painted just like wax figures in clothes shops, and smell the strange fragrance of incense.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("However fascinating it was, I felt more at home in the tall, clear, white washed medieval cave of St Martin’s Church, at the foot of the tower on the square. This was in use by the oldest of the Presbyterian Churches in the Netherlands, the Dutch Reformed church. The minister of this church, I understood, was less serious than ours.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Inside St Martin’s church, the all-white walls and vaults contrasted with the dark brown oak of the woodwork, and of the richly embellished screen that concealed the many organ pipes that I knew were behind it. One day, when I passed through the church on the way home after school. I had sneaked up the steps that led to the organ and, to my astonishment, saw the")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6b681d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0024.vue
// module id = 132
// module chunks = 0